import * as React from 'react';
// @ts-ignore
import Parcel from 'single-spa-react/lib/esm/parcel';
import { mountRootParcel } from 'single-spa';
import { useTranslation } from 'react-i18next';
import { parse } from 'url';
import { push } from 'connected-react-router';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { KeycloakContext } from 'init/App';
import { useConfig } from '../../hooks/config';
import type { Props } from '@unitedtraders/deposit-microfrontend';

export const Deposit: React.FC = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const keycloak = React.useContext(KeycloakContext)!;

  const config = useConfig();

  const { pathname } = useLocation();

  const [, baseUrl, homeUrl] = pathname.match(/^((.*)\/deposit)/)!;

  const dispatch = useDispatch();

  const depositConfig: Props['appConfig'] = {
    graphqlGateway: config.graphqlGateway,
    utcomGateway: {
      rest: {
        url: parse(config.grpcGateway.url),
      },
    },
    utexWallet: {
      url: config.utexWalletsUrl,
    },
  };

  const props: Props = {
    locale: language,
    getTokens: () => keycloak.getTokens(),
    appConfig: depositConfig,
    baseUrl,
    closeModal: () => dispatch(push(homeUrl)),
    onSuccessButtonClick: () => (window.location.href = '/investments'),
  };

  return (
    <Parcel
      config={() => import('@unitedtraders/deposit-microfrontend')}
      mountParcel={mountRootParcel}
      {...props}
    />
  );
};
